import { render, staticRenderFns } from "./AddAdAccount.vue?vue&type=template&id=24fb7339"
import script from "./AddAdAccount.vue?vue&type=script&lang=ts"
export * from "./AddAdAccount.vue?vue&type=script&lang=ts"
import style0 from "./AddAdAccount.vue?vue&type=style&index=0&id=24fb7339&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports